import React from 'react';

import useReportQueryParams from '../../../hooks/use-report-query-params';
import OverallCards from './OverallCards';
import OrganizationClassroomEngagementCards from './ClassroomEngagementCards';
import SchoolEngagementCards from './SchoolEngagementCards';
import { ReportEntityType } from 'components/ReportsModule/types';

const ORGANIZATION_ENGAGEMENT_MAP: { [key in ReportEntityType]?: any } = {
  [ReportEntityType.DISTRICT]: SchoolEngagementCards,
  [ReportEntityType.SCHOOL]: OrganizationClassroomEngagementCards,
  [ReportEntityType.USER_GROUP]: OrganizationClassroomEngagementCards,
  [ReportEntityType.USER]: OrganizationClassroomEngagementCards
};

const KeyboardingOrganizationReport: React.FC = () => {
  const [{ entityId, entityType }] = useReportQueryParams();

  if (!entityId) return null;

  const EngagementCards = ORGANIZATION_ENGAGEMENT_MAP[entityType];

  return (
    <>
      <OverallCards />
      <EngagementCards />
    </>
  );
};

export default KeyboardingOrganizationReport;
